module.exports = __webpack_public_path__ + "img/3.93703c60.png";